import React from 'react'
import { getPageMargins } from '../../../../configurations/GlobalConfig'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo'
import QRCode from 'react-qr-code'
import { DOCTOR_URL } from '../../../../configurations/initUrls'
import Dp from './../../../../components/app/users/Dp'
export const ProfilePrint = React.forwardRef((data, ref) => {
    const userData = getLoginInfo()
    return (
        <div ref={ref}>
            <style type="text/css">
                {getPageMargins()}
            </style>
            {
                userData &&
                <div className='p-6 border border-gray-700 w-full bg-gradient-to-r from-blue-100 to-emerald-100 h-[719px] flex flex-col items-center justify-center' style={{ WebkitPrintColorAdjust: "exact" }}>
                    <div className="w-full flex flex-col justify-between items-center gap-3">
                        <div>
                            <div className="flex-shrink-0">
                                <Dp user={userData} height={"h-36"} width={"w-36"} isNewUser={true} />
                            </div>
                        </div>
                        <div className='w-full flex flex-col justify-center items-center'>
                            {userData &&
                                <h3 className="text-3xl font-semibold text-gray-800">
                                    Dr. {userData && userData.fullName}
                                </h3>
                            }
                            <div>
                                <h3 class="text-lg text-center">
                                    {userData.specialisation?.name} ({userData.specialisation?.shortName})
                                </h3>
                                <h3 class="text-lg text-center">
                                    {userData.degree}
                                </h3>
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <QRCode className='w-full' value={DOCTOR_URL + userData.doctorId} />
                            <p className="text-lg text-gray-600 mt-1">scan to register appoinment</p>
                        </div>
                        <div className='flex flex-col items-center'>
                            <span className='text-[12px]'>Powered By</span>
                            <img className="h-5 w-auto" src="/assets/images/logo.png" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
})
